import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery/dist/jquery.min.js";
import React from "react";
import "react-notifications-component/dist/theme.css";
import authenticationService from "../auth/AuthenticationService";
import { handleResponse } from "../auth/handle-response";
import { url } from "../config/config";
import "./BatchMaterialReport.css"; // Import CSS
import { withRouter } from "react-router-dom";
import ChangeWorkerDialog from "./ChangeWorkerDialog";
import NotificationService from "../services/NotificationService";
import util from "../services/Utility";
import { Button } from "@material-ui/core";
import UserSetting from "../services/UserSetting";
import loadingGif from '../static/images/loading.gif';
import ChangeFlagDialog from './ChangeFlagDialog';
import { FlagContext } from "../context/FlagContext";

class BatchMaterialReport extends React.Component {
  
  static contextType = FlagContext;

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      items: null,
      filteredData: null,
      timer: 900, // Seconds
      searchQuery: "",
      workers: [], // List of workers
      selectedWorker: "", // Selected worker ID
      isDialogOpen: false,
      currItem: null, // Only Use for Change worker btn user click on item it assigned to currItem
      expandedCategories: {}, // Track which categories are expanded
      flagDialogOpen: false,
      flagDialogData: {},
    };
  }

  groupDataByDepartment(data) {
    // Parse today's date once
    const today = new Date().toISOString().split("T")[0];

    // Create initial grouped data without sorting
    const groupedData = data.reduce((groups, item) => {
      // Parse the date only once
      const isToday = item.batch_date === today;
      const key = item.msg_key;

      // Initialize group if it doesn’t exist
      if (!groups[key]) {
        groups[key] = {
          items: [],
          totalQty: 0,
          itemCount: 0,
          todayTotalQty: 0,
          todayItemCount: 0,
        };
      }

      // Group items and update quantities
      item.isToday = isToday;
      groups[key].items.push(item);
      groups[key].totalQty += item.b_qty;
      groups[key].itemCount += 1;

      // Update today's totals if the item date matches today
      if (isToday) {
        groups[key].todayTotalQty += item.b_qty;
        groups[key].todayItemCount += 1;
      }

      return groups;
    }, {});

    // Convert groupedData to an array of entries, sort by key, round totals, and convert back to an object
    const sortedGroups = Object.fromEntries(
      Object.entries(groupedData)
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .map(([key, group]) => {
          group.totalQty = util.getRoundOff(group.totalQty, false); // Round off totalQty once after grouping
          return [key, group];
        })
    );

    return sortedGroups;
  }

  // Function to toggle the expansion of a category
  toggleCategory(key) {
    this.setState((prevState) => ({
      expandedCategories: {
        [key]: !prevState.expandedCategories[key],
      },
    }));
  }

  componentDidMount() {
    if (localStorage.getItem("UserSetting")!=null) {
      UserSetting.setSettings(JSON.parse(util.decodeString(localStorage.getItem("UserSetting"))));
    } else {
      this.getUserSettings();
    }
    this.sendBRMRequest();
  }

  componentWillUnmount() {
    // Clear the timer when the component unmounts
    clearInterval(this.timerID);
    clearInterval(this.disTimerID);
  }

  async getFlagData() {
    try {
      const response = await axios.get(`${url}prod/getFlags`, {
        params: {
          key: authenticationService.getAuthToken(),
          flagIds: UserSetting.getFlags(),
          latitude: authenticationService.getUserLatitude(),
          longitude: authenticationService.getUserLongitude(),
          phone: authenticationService.getMobileNo(),
        },
      });

      const res = handleResponse(response);

      if (!res || res.length <= 0) {
        NotificationService.error("Failed to get flags");
        return;
      }

      // Access context methods via `this.context`
      const { setFlagResponse } = this.context; 

      if (typeof setFlagResponse === "function") {
        setFlagResponse(res);
        console.log("Flags Recieved:");
        // NotificationService.success("Get flags Success!");
      } else {
        // NotificationService.error("Flags Request failed");
        console.error("Flags Request failed");
      }
    } catch (error) {
      // NotificationService.error("Flags Request failed");
      console.error("Flags Error:", error);
    }
  }

  async getUserSettings() {
    const authToken = authenticationService.getAuthToken();

    await axios
      .get(`${url}prod/userSettings?key=${authToken}`)
      .then(handleResponse)
      .then((res) => {
        if (res === "") {
          NotificationService.error("No Settings Found");
          return;
        }
        console.log("Settings Recieved");
        localStorage.setItem("UserSetting", util.encodeString(JSON.stringify(res)));
        UserSetting.setSettings(res);
        if (UserSetting.getFlags() != null && UserSetting.getFlags() !== "") {
          this.getFlagData();
        }
        // this.sendBRMRequest();
      })
      .catch((error) => {
        console.error("Error in request:", error);
      });
  }

  async sendBRMRequest() {
    // Retrieve the remaining time from localStorage (if it exists)
    // const storedTime = localStorage.getItem("remainingTimer");
    // if (storedTime) {
    //   this.setState({ timer: parseInt(storedTime, 10) });
    // }

    // const {
    //   match: { params },
    // } = this.props;

    const authToken = authenticationService.getAuthToken();

    await axios
      .post(`${url}prod/bmr?key=${authToken}`)
      .then(handleResponse)
      .then((res) => {
        // console.log("BMR RESPONSE: " + JSON.stringify(res));
        if (res === "") {
          NotificationService.error("No Report Found");
          return;
        }
        this.setState({
          data: res,
          items: res,
          // group: params.ledId,
          filteredData: res,
        });
      })
      .catch((error) => {
        console.error("Error in axios request:", error);
      });
    this.startTimer();
    this.isValidDistanceTimer();
  }

  isValidDistanceTimer = () => {
    this.disTimerID = setInterval(() => {
      authenticationService.isValidDistance();
    }, 10000); // Update timer every Minute
  };

  startTimer = () => {
    this.timerID = setInterval(() => {
      this.setState(
        (prevState) => {
          const newTime = prevState.timer - 1;
          // localStorage.setItem("remainingTimer", newTime);
          return { timer: newTime };
        },
        () => {
          if (this.state.timer <= 0) {
            // localStorage.removeItem("remainingTimer");
            authenticationService.signOut();
            this.props.history.replace("/");
          }
        }
      );
    }, 1000); // Update timer every second
  };

  handleFiltering = (searchQuery) => {
    const filteredData = this.state.data.filter((item) => {
      const searchRegex = new RegExp(searchQuery, "i");
      return (
        searchRegex.test(item.client_lot_No) ||
        searchRegex.test(item.lot_name) ||
        searchRegex.test(item.artNo) ||
        searchRegex.test(item.worker_name) ||
        searchRegex.test(item.item_name) ||
        searchRegex.test(item.flagMessage) ||
        searchRegex.test(item.failMessage) ||
        searchRegex.test(item.ord_no) ||
        searchRegex.test(item.rate_type)
      );
    });
    this.setState({ filteredData, searchQuery }); // Update filteredData and searchQuery state
  };

  async issueDialog(item) {
    await axios
      .post(`${url}prod/getJobsForQuality`, null, {
        params: {
          key: authenticationService.getAuthToken(),
          batch_no: item.prev_batch + "," + item.batch_id,
          notFlex: item.clearForSale,
          process_id: item.process_id,
        },
      })
      .then(handleResponse)
      .then((res) => {
        authenticationService.addTime();
        // console.log("Res: " + JSON.stringify(res));
        if (res == null || res.length <= 0) {
          NotificationService.error("No Data Found");
          return;
        }

        // Handle success
        // alert("Get Issue Success!");
        localStorage.setItem("ITEM", JSON.stringify(item));
        localStorage.setItem("response", JSON.stringify(res));
        this.props.history.push("/prod/issue");
        // window.open("../prod/issue/", "_blank");
      })
      .catch((error) => {
        NotificationService.error("Request failed");
        console.error("Error:", error);
      });
  }

  async changeWorker(item) {
    // console.log("CHange Worker: " + JSON.stringify(item));
    if (util.getConsumed(item) !== "0.000") {
      NotificationService.error("Already Consumed");
      return;
    }

    await axios
      .post(`${url}prod/getWorkersForDep`, null, {
        params: {
          key: authenticationService.getAuthToken(),
          dep_id: item.dep_id,
        },
      })
      .then(handleResponse)
      .then((res) => {
        // console.log("getWorkersForDep Res: " + JSON.stringify(res));
        if (res == null || res.length <= 0) {
          NotificationService.error("No Worker Found");
          return;
        }
        this.setState({ currItem: item }); // Assign Item Which is currently selected
        const workerMap = res
          .replace(/[{}]/g, "")
          .split(", ")
          .map((item) => {
            const [id, name] = item.split("=");
            return { id, name };
          })
          .filter((worker) => worker.name !== item.worker_name) // Exclude current workers
          .sort((a, b) => a.name.localeCompare(b.name)); // Sort based on name
        this.setState({ workers: workerMap, isDialogOpen: true });
        // console.log(
        //   "getWorkersForDep Res: " + JSON.stringify(this.state.workers)
        // );
      })
      .catch((error) => {
        NotificationService.error("Request failed");
        console.error("Error:", error);
      });
  }

  handleWorkerChange = (workerId) => {
    this.setState({ selectedWorker: workerId });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  handleDialogSubmit = (workerId) => {
    // console.log("Selected Worker ID:", workerId);
    // console.log("currItem: " + JSON.stringify(this.state.currItem));
    if (this.state.currItem == null) {
      return;
    }
    this.setState({ isDialogOpen: false, currItem: null });
    this.sendChangeWorkerRequest(this.state.currItem.batch_id, workerId);
  };

  handleFlagClick = (key, value) => {
    // console.log(`flag_color clicked with item: ${JSON.stringify(value)}`);
    switch (key) {
      case "flag_color":
        // console.log(
        //   `flag_color clicked with value: ${value.way_form || "#ffffff"}`
        // );
        break;
      case "flag_add":
        if (!UserSetting.canChangeFlag()) {
          NotificationService.error("Not Authorized!");
          return;
        }
        // console.log(`flag_add clicked`);
        this.addFlagAction(key, value);
        break;
      case "flag_name":
        if (!UserSetting.canChangeFlag()) {
          NotificationService.error("Not Authorized!");
          return;
        }
        // console.log(`flag_name clicked with value: ${value.rate_type}`);
        this.changeFlagAction(key, value);
        break;
        case "flag_remark":
          if (!UserSetting.canChangeFlagRemark()) {
          NotificationService.error("Not Authorized!");
          return;
        }
        // console.log(`flag_remark clicked with value: ${value.ord_no}`);
        this.changeFlagRemarkAction(key, value);
        break;
      default:
        console.log(`Unknown key clicked: ${key} with value: ${value}`);
    }
  };

  async sendChangeFlagRequest(formData, item) {
    const { getFlagByName } = this.context; 

    if(formData.flag_id < 1){
      NotificationService.error("Invalid Flag Request.");
      return;
    }

    const requestBody = {
      tableConstant: 2, // TableConstants.ISSUE_SLIP_CHILD
      master_ids: [item.tran_id],
      flag_id: formData.flag_id,
      remarks: formData.textFieldValue,
    }
    await axios
    .post(`${url}prod/changeFlagInfo`, requestBody, {
      params: {
        key: authenticationService.getAuthToken(),
        latitude: authenticationService.getUserLatitude(),
        longitude: authenticationService.getUserLongitude(),
        phone: authenticationService.getMobileNo(),
      },
    })
    .then(handleResponse)
    .then((res) => {
        authenticationService.addTime();
        switch (res.response_id) {
          case 670:
            NotificationService.success("Flag Updation Success");
            break;
          case 671:
            NotificationService.error("Flag Updation Failed.");
            break;
          default:
            break;
        }
      // console.log("changeFlagInfo Res: " + JSON.stringify(res));
    })
    .catch((error) => {
      NotificationService.error("Request failed");
      console.error("Error:", error);
    });
  }

  changeFlagAction = (type, item) => {
    if(!this.isFlagAssigned()){
      NotificationService.error("No flag assigned for change!");
      return;
    }
    const { getFlagNames, getColorByFlagName, getFlagByName } = this.context; 
    const flagNames = getFlagNames();

    this.setState({
      flagDialogOpen: true,
      flagDialogData: {
        onClose: () => {
          this.setState({ flagDialogOpen: false });
        },
        onSubmit: (formData) => {
          this.setState({ flagDialogOpen: false });
          formData.flag_id = getFlagByName(formData.comboBoxValue).flagId
          this.sendChangeFlagRequest(formData, item);
        },
        dialogName: "Change Flag",

        comboLabel: "Select Flag",
        comboBoxData:flagNames,
        initComboBoxValue: flagNames[0],
        onComboBoxChange: (salectedFlag) => {
          return getColorByFlagName(salectedFlag);
        },

        divLabel: "Color",
        initDivValue: getColorByFlagName(flagNames[0]),

        initTextFieldValue: item.ord_no,
        showComboBox: true,
        showDetailsDiv: true,
        showTextField: false,
      },
    });
  };
  
  addFlagAction = (type, item) => {
    if(!this.isFlagAssigned()){
      NotificationService.error("No flag assigned for change!");
      return;
    }
    const { getFlagNames, getColorByFlagName, getFlagByName } = this.context; 
    const flagNames = getFlagNames();

    this.setState({
      flagDialogOpen: true,
      flagDialogData: {
        onClose: () => {
          this.setState({ flagDialogOpen: false });
        },
        onSubmit: (formData) => {
          this.setState({ flagDialogOpen: false });
          formData.flag_id = getFlagByName(formData.comboBoxValue).flagId
          this.sendChangeFlagRequest(formData, item);
        },
        dialogName: "Attach Flag",

        comboLabel: "Select Flag",
        comboBoxData:flagNames,
        initComboBoxValue: flagNames[0],
        onComboBoxChange: (salectedFlag) => {
          return getColorByFlagName(salectedFlag);
        },

        textFieldLabel: "Enter Remarks",
        initTextFieldValue: "",

        divLabel: "Color",
        initDivValue: getColorByFlagName(flagNames[0]),
        showComboBox: true,
        showDetailsDiv: true,
        showTextField: true,
      },
    });
  };

  changeFlagRemarkAction = (type, item) => {
    // if(!this.isFlagAssigned()){
    //   NotificationService.error("No flag assigned for change!");
    //   return;
    // }
    this.setState({
      flagDialogOpen: true,
      flagDialogData: {
        onClose: () => {
          this.setState({ flagDialogOpen: false });
        },
        onSubmit: (formData) => {
          this.setState({ flagDialogOpen: false });
          formData.flag_id = item.flag_id;
          this.sendChangeFlagRequest(formData, item);
        },
        dialogName: "Change Flag Remark",

        initComboBoxValue: item.rate_type,

        textFieldLabel: "Enter Remarks",
        initTextFieldValue: item.ord_no,

        showComboBox: false,
        showDetailsDiv: false,
        showTextField: true,
      },
    });
  };

  isFlagAssigned = () => { 
    const { getFlagNames } = this.context; 
    const flagNames = getFlagNames();
    if (!flagNames || flagNames.length < 1) {
      return false;
    }
    return true;
  }

  async sendChangeWorkerRequest(batch_id, workerId) {
    await axios
      .post(`${url}prod/changeWorker`, null, {
        params: {
          key: authenticationService.getAuthToken(),
          workerId: workerId,
          slipNo: batch_id,
          latitude: authenticationService.getUserLatitude(),
          longitude: authenticationService.getUserLongitude(),
          phone: authenticationService.getMobileNo(),
        },
      })
      .then(handleResponse)
      .then((res) => {
        console.log("getWorkersForDep Res: " + JSON.stringify(res));
        if (res == null || res.length <= 0) {
          NotificationService.error("Failed to changer Worker");
          return;
        }

        const responseId = res.response_id;
        // 605 -> Change Worker Success
        if (responseId !== 605) {
          NotificationService.error("Failed to changer Worker");
          return;
        }
        NotificationService.success("Worker Changed Success!");
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        NotificationService.error("Request failed");
        console.error("Error:", error);
      });
  }

  render() {
    const { filteredData, expandedCategories, data } = this.state;
    const dataToDisplay = filteredData || data; // Show filtered data if it exists
    if (data === null || dataToDisplay === null) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}>
          <img
            src={loadingGif}
            alt="Loading Data......."
            style={{
              width: "300px",
              height: "auto",
            }}
          />
        </div>
      );
    }
    const groupedData = this.groupDataByDepartment(dataToDisplay);
    const { flagDialogOpen, flagDialogData } = this.state;
    return (
      <div>
        <div className="container-fluid mt-3">
          <div className="row align-items-center responsive-row">
            <div className="col-auto">
              <h2 className="font-weight-bold responsive-heading">
                Batch Material Report
              </h2>
            </div>
            <div className="col-auto">
              <p className="mb-0 responsive-timer">
                Timer: {util.formatTime(this.state.timer)}
              </p>
            </div>
            <div className="col responsive-input-wrapper">
              <input
                type="text"
                className="form-control responsive-input"
                placeholder="Type anything..."
                value={this.state.searchQuery}
                onChange={(e) => this.handleFiltering(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Dialog */}
        {flagDialogOpen && (
          <ChangeFlagDialog open={flagDialogOpen} {...flagDialogData} />
        )}

        <div className="container-fluid my-3">
          <div className="table-responsive">
            {Object.keys(groupedData).map((key) => (
              <div key={key}>
                <div
                  className="category-header d-flex align-items-center justify-content-between"
                  onClick={() => this.toggleCategory(key)}>
                  <h5 className="mb-0">
                    <strong>{key}</strong> [ Batch: {groupedData[key].itemCount}
                    , Qty: {groupedData[key].totalQty} ]{" "}
                    <strong>Today's: </strong>[ Batch:{" "}
                    {groupedData[key].todayItemCount}, Qty:{" "}
                    {groupedData[key].todayTotalQty} ]
                  </h5>
                  <span
                    className={`arrow ${
                      expandedCategories[key] ? "expanded" : ""
                    }`}>
                    {expandedCategories[key] ? "-" : "+"}
                  </span>
                </div>
                {expandedCategories[key] && (
                  <table className="table table-bordered table-responsive-sm table-sm align-middle align mt-3">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th className="min-width-col">
                          <span className="blue-text">Date</span>
                          <br />
                          Lot
                          <br />
                          <span className="green-text">Batch</span>
                        </th>
                        <th className="min-width-col">
                          <span className="blue-text">Lot Name</span>
                          <br />
                          Art No.
                        </th>
                        <th className="min-width-col">
                          <span className="blue-text">Process</span>
                          <br />
                          Worker
                        </th>
                        <th>
                          <span className="blue-text">From Worker</span>
                          <br />
                          Qty In
                          <br />
                          <span className="green-text">Consumed</span>
                        </th>
                        <th>
                          <span className="blue-text">Item</span>
                          <br />
                          Type
                          <br />
                          <span className="green-text">Style</span>
                        </th>
                        <th>
                          <span className="blue-text">Master</span>
                          <br />
                          Remarks
                        </th>
                        <th>
                          <span className="blue-text">Flag</span>
                          <br />
                          Flag Remarks
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedData[key].items.map((item, index) => (
                        <tr
                          key={index}
                          className={item.isToday ? "highlight-row" : ""}>
                          {/* Column 1: S.No | Issue | Balance */}
                          <td className="d-flex flex-column align-items-center">
                            {index + 1}
                            <br />
                            {UserSetting.canIssue() && (
                              <button
                                className="btn btn-success m-0"
                                id="btnDetail"
                                onClick={() => this.issueDialog(item)}>
                                Issue
                                <br />
                                {util.getRoundOff(item.b_qty, true)}
                              </button>
                            )}
                          </td>

                          {/* Column 2: Date | Lot | Batch */}
                          <td className="align-middle h6">
                            <span className="blue-text">
                              {util.formatDateToDDMMYY(item.batch_date)}
                            </span>
                            <br />
                            {item.client_lot_No}
                            <br />
                            <span className="green-text">
                              {item.client_batch_no}
                            </span>
                          </td>

                          {/* Column 3: Lot Name | Art No. */}
                          <td className="align-middle h6">
                            <span className="spanlue-text">
                              {item.lot_name}
                            </span>
                            <br />
                            {item.artNo}
                          </td>

                          {/* Column 4: Process | Worker */}
                          <td className="align-middle h6">
                            <span className="blue-text">{item.oldName}</span>
                            <br />
                            {item.worker_name}
                          </td>

                          {/* Column 5: From Worker | Qty In | Consumed */}
                          <td className="align-middle h6">
                            <span className="blue-text">
                              {item.from_worker}
                            </span>
                            <br />
                            <span
                              style={{ display: "block", textAlign: "right" }}>
                              {util.getRoundOff(item.b_qty, true)}
                              <br />
                            </span>
                            <span
                              className="green-text"
                              style={{ display: "block", textAlign: "right" }}>
                              {util.getConsumed(item)}
                            </span>
                          </td>

                          {/* Column 6: Item | Type | Style*/}
                          <td className="align-middle h6">
                            <span className="blue-text">{item.item_name}</span>
                            <br />
                            {item.type_id > 0 ? item.flagMessage : ""}
                            <br />
                            <span className="green-text">
                              {item.style_id > 0 ? item.failMessage : ""}
                            </span>
                          </td>

                          {/* Column 7: Change Worker | Master | Remarks */}
                          <td className="align-middle h6">
                            {UserSetting.canChangeWorker() && (
                              <div>
                                {/* Trigger the dialog */}
                                <Button
                                  onClick={() => this.changeWorker(item)}
                                  color="primary"
                                  variant="contained"
                                  size="small"
                                  disableElevation>
                                  Change Worker
                                </Button>

                                {/* Change Worker Dialog */}
                                <ChangeWorkerDialog
                                  open={this.state.isDialogOpen}
                                  workers={this.state.workers}
                                  selectedWorker={this.state.selectedWorker}
                                  onClose={this.handleDialogClose}
                                  onSubmit={this.handleDialogSubmit}
                                  onWorkerChange={this.handleWorkerChange}
                                />
                              </div>
                            )}
                            <br />
                            <span className="blue-text">
                              {item.from_remarks}
                            </span>
                            <br />
                            {item.remarks}
                          </td>

                          {/* Column 8: Color | Flag | Flag Remarks*/}
                          <td className="align-middle h6">
                            {UserSetting.canChangeFlag() &&
                              item.rate_type == null && (
                                <Button
                                  onClick={() => this.handleFlagClick("flag_add", item)}
                                  color="primary"
                                  variant="contained"
                                  size="small"
                                  disableElevation>
                                  Add Flag
                                </Button>
                              )}
                            <div
                              style={
                                item.way_form
                                  ? {
                                      backgroundColor: `#${item.way_form}`,
                                      height: "25px",
                                      cursor: "pointer",
                                    }
                                  : {}
                              }
                              onClick={() =>
                                this.handleFlagClick("flag_color", item)
                              }></div>
                            <span
                              className="blue-text"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.handleFlagClick("flag_name", item)
                              }>
                              {item.rate_type}
                            </span>
                            <br />
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.handleFlagClick("flag_remark", item)
                              }>
                              {item.ord_no}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BatchMaterialReport);

// {index + 1} -> S.No
// {item.batch_date} -> Date
// {item.client_lot_No} -> Lot No.
// {item.client_batch_no} -> Batch No.
// {item.lot_name} -> Lot Name
// {item.from_remarks} -> Master
// {item.artNo} -> Art No.
// {item.worker_name} -> Worker
// {item.item_name} -> Item
// {item.flagMessage} -> Type Name
// {item.failMessage} -> Style Name
// {item.qty} -> Qty In
// {util.getConsumed(item)} -> Consumed
// {item.job_rate} -> Return
// {item.b_qty} -> Balance
// {item.remarks} -> Remarks
// {item.oldName} -> Process
// {item.from_worker} -> From Worker
// {item.msg_key} -> Department
// {item.lot_birth_date} -> Start Dt.
// {this.getDaysDifference(item.lot_birth_date)} -> Age
// {this.getDaysDifference(item.batch_date)} -> Batch Age
